"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CrossSellItemsTypes = void 0;
var CrossSellItemsTypes;
(function (CrossSellItemsTypes) {
    CrossSellItemsTypes["TREATMENT"] = "treatment";
    CrossSellItemsTypes["SPATREATMENT"] = "spa-treatment";
    CrossSellItemsTypes["PRODUCT"] = "product";
    CrossSellItemsTypes["SPADAY"] = "spa-day";
    CrossSellItemsTypes["VOUCHER"] = "voucher";
    CrossSellItemsTypes["EVENT"] = "event";
})(CrossSellItemsTypes || (exports.CrossSellItemsTypes = CrossSellItemsTypes = {}));
